import {createRouter, createWebHistory} from 'vue-router';
import Home from '@/views/Dashboard/index.vue';
import HomeContent from '@/views/Dashboard/components/HomeContent.vue';
import Editor from '@/views/Editor/index.vue';
import Login from '@/views/Auth/index.vue'
import Screen from './views/Screen/index.vue'
import Mobile from './views/Mobile/index.vue'
import Unauthorized from './views/Unauthorized/index.vue'
import Search from '@/views/Search/index.vue'
import {useAuthStore, useMainStore} from '@/store'
import useMicroservice from '@/hooks/useMicroservice';


import {storeToRefs} from "pinia";
import authHelper from '@/views/Auth/authHelper'


export const router = () => {
    const routes = [
        {
            path: '/home',
            component: Home,
            children: [
                {
                    path: '/home',
                    components: {
                        default: Home,
                        col2: HomeContent
                    }
                },
                {
                    path: '/search',
                    components: {
                        default: Home,
                        col2: Search
                    }
                },

            ]
        },
        {name: 'editor', path: '/editor', component: Editor},
        {name: '/regression/editor', path: '/regression/editor', component: Editor},
        {path: '/login', component: Login},
        {path: '/screen', component: Screen},
        {path: '/mobile', component: Mobile},
        {path: '/unauthorized', component: Unauthorized},
    ];

    const router = createRouter({
        history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
        routes,
    });


    router.beforeEach(async (to, from, next) => {
        const {checkValidSession} = await authHelper()
        await checkValidSession()
        const authStore = useAuthStore();
        const {loggedIn, targetUrl} = storeToRefs(authStore);


        if (!loggedIn.value && to.path !== '/login') {
            targetUrl.value = to.fullPath
            next('/login');
        } else if (loggedIn.value && to.path === '/login') {
            const redirectPath = authStore.targetUrl || '/home'
            targetUrl.value = ''
            next(redirectPath);
        } else {
            next();
        }

    });

    router.beforeResolve(async (to, from, next) => {

        const mainStore = useMainStore();

        mainStore.slideEditorLoading = true;

        if (to.path.startsWith('/editor') || to.path.startsWith('/regression/editor')) {
            const { loadValueModel } = useMicroservice()
            const authStore = useAuthStore();
            const {loggedInUser} = storeToRefs(authStore)
            const deckId = to.query.id ? String(to.query.id) : String(to.query.deckId)
            const calcId = to.query.calcId ? String(to.query.calcId) : ''

            const allUser = !loggedInUser.value.email.endsWith('@leveragepoint.com')

            const event = new CustomEvent("hotjar", {
                "detail": {
                    "allUser": allUser
                }
            });

            document.dispatchEvent(event);

            const vmId = String(to.query.vmId)

            try {
                await loadValueModel(deckId, vmId, calcId)

            }
            catch(e) {
                if (e === 'Could not get model') {
                    mainStore.slideEditorLoading = false;
                    next('/unauthorized')
                    return
                }
            }
        }
        next()
    })

    router.afterEach(async () => {
        const mainStore = useMainStore();
        mainStore.slideEditorLoading = false;
    });

    return router
}
